const PrepDerm = () => {
	return (
		<div className='overflow-hidden bg-white py-24 sm:py-32'>
			<div className='mx-auto max-w-2xl px-6 lg:max-w-7xl lg:px-8'>
				<div className='max-w-4xl'>
					<p className='text-base/7 font-semibold text-indigo-600'>About us</p>
					<h1 className='mt-2 text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl'>
						On a mission to empower remote teams
					</h1>
					<p className='mt-6 text-xl/8 text-balance text-gray-700'>
						Aliquet nec orci mattis amet quisque ullamcorper neque, nibh sem. At
						arcu, sit dui mi, nibh dui, diam eget aliquam. Quisque id at vitae
						feugiat egestas.
					</p>
				</div>
				<section className='mt-20 grid grid-cols-1 lg:grid-cols-2 lg:gap-x-8 lg:gap-y-16'>
					<div className='lg:pr-8'>
						<h2 className='text-2xl font-semibold tracking-tight text-pretty text-gray-900'>
							Our mission
						</h2>
						<p className='mt-6 text-base/7 text-gray-600'>
							Faucibus commodo massa rhoncus, volutpat. Dignissim sed eget risus
							enim. Mattis mauris semper sed amet vitae sed turpis id. Id dolor
							praesent donec est. Odio penatibus risus viverra tellus varius sit
							neque erat velit. Faucibus commodo massa rhoncus, volutpat.
							Dignissim sed eget risus enim. Mattis mauris semper sed amet vitae
							sed turpis id.
						</p>
						<p className='mt-8 text-base/7 text-gray-600'>
							Et vitae blandit facilisi magna lacus commodo. Vitae sapien duis
							odio id et. Id blandit molestie auctor fermentum dignissim. Lacus
							diam tincidunt ac cursus in vel. Mauris varius vulputate et
							ultrices hac adipiscing egestas. Iaculis convallis ac tempor et
							ut. Ac lorem vel integer orci.
						</p>
					</div>
					<div className='pt-16 lg:row-span-2 lg:-mr-16 xl:mr-auto'>
						<div className='-mx-8 grid grid-cols-2 gap-4 sm:-mx-16 sm:grid-cols-4 lg:mx-0 lg:grid-cols-2 lg:gap-4 xl:gap-8'>
							<div className='aspect-square overflow-hidden rounded-xl shadow-xl outline-1 -outline-offset-1 outline-black/10'>
								<img
									alt=''
									className='block size-full object-cover'
									src='https://images.unsplash.com/photo-1590650516494-0c8e4a4dd67e?&auto=format&fit=crop&crop=center&w=560&h=560&q=90'
								/>
							</div>
							<div className='-mt-8 aspect-square overflow-hidden rounded-xl shadow-xl outline-1 -outline-offset-1 outline-black/10 lg:-mt-40'>
								<img
									alt=''
									className='block size-full object-cover'
									src='https://images.unsplash.com/photo-1557804506-669a67965ba0?&auto=format&fit=crop&crop=left&w=560&h=560&q=90'
								/>
							</div>
							<div className='aspect-square overflow-hidden rounded-xl shadow-xl outline-1 -outline-offset-1 outline-black/10'>
								<img
									alt=''
									className='block size-full object-cover'
									src='https://images.unsplash.com/photo-1559136555-9303baea8ebd?&auto=format&fit=crop&crop=left&w=560&h=560&q=90'
								/>
							</div>
							<div className='-mt-8 aspect-square overflow-hidden rounded-xl shadow-xl outline-1 -outline-offset-1 outline-black/10 lg:-mt-40'>
								<img
									alt=''
									className='block size-full object-cover'
									src='https://images.unsplash.com/photo-1598257006458-087169a1f08d?&auto=format&fit=crop&crop=center&w=560&h=560&q=90'
								/>
							</div>
						</div>
					</div>
					<div className='max-lg:mt-16 lg:col-span-1'>
						<p className='text-base/7 font-semibold text-gray-500'>
							The numbers
						</p>
						<hr className='mt-6 border-t border-gray-200' />
						<dl className='mt-6 grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2'>
							<div className='flex flex-col gap-y-2 border-b border-dotted border-gray-200 pb-4'>
								<dt className='text-sm/6 text-gray-600'>Raised</dt>
								<dd className='order-first text-6xl font-semibold tracking-tight'>
									$<span>150</span>M
								</dd>
							</div>
							<div className='flex flex-col gap-y-2 border-b border-dotted border-gray-200 pb-4'>
								<dt className='text-sm/6 text-gray-600'>Companies</dt>
								<dd className='order-first text-6xl font-semibold tracking-tight'>
									<span>30</span>K
								</dd>
							</div>
							<div className='flex flex-col gap-y-2 max-sm:border-b max-sm:border-dotted max-sm:border-gray-200 max-sm:pb-4'>
								<dt className='text-sm/6 text-gray-600'>Deals Closed</dt>
								<dd className='order-first text-6xl font-semibold tracking-tight'>
									<span>1.5</span>M
								</dd>
							</div>
							<div className='flex flex-col gap-y-2'>
								<dt className='text-sm/6 text-gray-600'>Leads Generated</dt>
								<dd className='order-first text-6xl font-semibold tracking-tight'>
									<span>200</span>M
								</dd>
							</div>
						</dl>
					</div>
				</section>
			</div>
		</div>
	);
};

export default PrepDerm;
